import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../store';
import { login, logout } from '../../store/slices/authSlice';
import { apiService } from '../../services';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, token } = useAppSelector(state => state.auth);
  const [isVerifying, setIsVerifying] = useState(!!token);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    if (!token) {
      setIsVerifying(false);
      return;
    }

    apiService.get<{ id: string; email: string; name: string; avatar_url: string; role: string }>('/auth/me')
      .then(user => {
        dispatch(login({ user, token }));
        setIsValid(true);
      })
      .catch(() => {
        dispatch(logout());
        setIsValid(false);
      })
      .finally(() => setIsVerifying(false));
  }, []);

  if (isVerifying) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex items-center gap-3 text-slate-400">
          <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          <span className="text-sm">Verifying session...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated && !isValid) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
